import { useLocation, useNavigate } from "react-router-dom";
import { AddressDetailCard, OrderDetail } from "./helper";
import { goToLink } from "../../projectData";
import { updateAddressVerification } from "./api";
import { FullPageLoader } from "../../../component/helper";
import { useState } from "react";
import confirmAlert from "../../../component/CustomAlert";
import { KTSVG } from "../../../../_metronic/helpers";
//import { toAbsoluteUrl } from "../../../_metronic/helpers";

/**
 * AddressReconfirm
 * Renders the address reconfirmation page, handles address update and navigation.
 */
const AddressReconfirm = () => {
    const [loader, setLoader] = useState(false)
    const navigate = useNavigate();
    const location = useLocation();
    const orders = location.state.orders;
    const addressData = location.state.address;
    const token = location.state.token;

    /**
     * updateAddress
     * Updates the address verification and handles success/error navigation.
     */
    const updateAddress = (addressData) => {
        setLoader(true)
        const newAddress = { ...addressData, request_token: token }
        updateAddressVerification(newAddress).then((d) => {

            setTimeout(() => {
                setLoader(false)
                if (Number(d.code) === 0) {
                    confirmAlert({
                        title: '',
                        text: d?.message,
                        icon: 'error',
                        buttons: ['OK'],
                    })
                } else {
                    goToLink(navigate, '/customer/address/success', location?.state)
                }
            }, 500)

        })

    }

    return (
        <>

            <div className="notice d-flex bg-light-danger rounded border-danger border border-dashed p-2">
                <div className="d-flex flex-column w-100">
                    <div className="d-flex border-1 border-danger border-bottom-dashed align-items-center">
                        <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-2x svg-icon-danger me-2' />
                        <h5 className="text-gray-900 pt-3 fw-semibold "> Are You Sure?</h5>
                    </div>
                    <div className=" mb-md-0 fw-semibold">
                        <div className="fs-7 p-2 text-gray-800">   Please confirm that your redemption address is correct.</div>
                    </div>
                </div>

            </div>

            <AddressDetailCard addressData={addressData} />
            <OrderDetail orders={orders} />

            <div className="d-flex w-100 align-items-center justify-content-center gap-4 mt-3">
                <button onClick={() => goToLink(navigate, `/customer/address/verify?request=${token}`)} className={'btn w-50 text-white bg-dark bg-hover-success'}>Cancel </button>
                <button onClick={() => updateAddress(addressData)} className='btn  w-50 text-white bg-danger bg-hover-success'> Re-Confirm</button>
            </div>
            {loader &&
                <FullPageLoader />
            }
        </>
    )

}

export default AddressReconfirm